import { buildEmployeeFilters } from 'actions/task';

import { buildLastActivityDateFilters } from './LastActivityDateFilter';
import { buildDueDateFilters } from './NewDueDateFilter';
import { buildObjectiveFilters } from './ObjectiveFilter';
import { buildPrimaryPodFilters } from './PrimaryPodFilter';
import { buildTagFilters } from './TagFilter';
import { buildTaskTypeFilters } from './TaskTypeFilter';

export default function buildTeamPageFilters(state, isGoalOptionSelected = false) {
  const employeeFilters = (state.employeeFilters && buildEmployeeFilters(state.employeeFilters)) || [];
  const primaryPodFilters = (state.primaryPodFilters && buildPrimaryPodFilters(state.primaryPodFilters)) || [];
  const taskTypeFilters = !isGoalOptionSelected
    ? (state.taskTypeFilters && buildTaskTypeFilters(state.taskTypeFilters, isGoalOptionSelected)) || []
    : [];
  const dueDateFilters = (state.dueDateFilters && buildDueDateFilters(state.dueDateFilters)) || [];
  // Completed filters don't get passed to filters api, hence we don't need to add them
  // because they throw error if we add them
  // they get sent as startTS and endTS values
  // const completedOnFilters = buildCompletedOnFilters(state.completedOnFilters);
  const objectiveFilters = (state.objectiveFilters && buildObjectiveFilters(state.objectiveFilters)) || [];
  const lastActivityDatefilters =
    (state.lastActivityDateFilters && buildLastActivityDateFilters(state.lastActivityDateFilters)) || [];
  const tagFilters = (state.tagFilters && buildTagFilters(state.tagFilters)) || [];
  const result = [
    ...employeeFilters,
    ...primaryPodFilters,
    ...taskTypeFilters,
    ...dueDateFilters,
    ...lastActivityDatefilters,
    // ...completedOnFilters,
    ...objectiveFilters,
    ...tagFilters,
  ];
  return result;
}
